import React from 'react';
import { Button } from '@vp/swan';
import PropTypes from 'prop-types';
import useSiteData from '../../../hooks/useSiteData';
import { trackNavigationClicked } from '../../../apis/trackingApi';

function ContinueShopping({ buttonText }) {
  const { externalAppNavigation } = useSiteData();

  const onClickHandler = () => {
    trackNavigationClicked({
      sourcePagePath: externalAppNavigation.cart,
      destinationPagePath: externalAppNavigation.base,
      ctaValue: 'continueShopping',
    });
  };

  return (
    <Button
      component="a"
      skin="secondary"
      width="full-width"
      href={externalAppNavigation.base}
      onClick={onClickHandler}
    >
      {buttonText}
    </Button>
  );
}

ContinueShopping.propTypes = {
  buttonText: PropTypes.string.isRequired,
};

export default ContinueShopping;
